import React from 'react'
import { Modal, Button } from 'antd'
import { FormattedMessage, injectIntl } from 'react-intl'

function DeleteEventConfirmModal({ intl, recurrent, eventStart, onCancel, onDeleteAll, onDeleteOccurrence }) {
	return (
		<Modal
			visible={true}
			title={intl.formatMessage({
				id: recurrent
					? 'messagePrograms.details.delete.confirm.title'
					: 'messagePrograms.details.delete.confirmOneTime.title'
			})}
			onCancel={onCancel}
			footer={
				recurrent ?
					[
						<Button key="cancel" onClick={onCancel}>
							<FormattedMessage id="actions.cancel" />
						</Button>,
						<Button key="occurrence" onClick={onDeleteOccurrence}>
							<FormattedMessage id="messagePrograms.details.confirm.instanceOnly" />
						</Button>,
						<Button key="all" type="danger" onClick={onDeleteAll}>
							<FormattedMessage id="messagePrograms.details.confirm.all" />
						</Button>
					]
				:	[
						<Button key="cancel" onClick={onCancel}>
							<FormattedMessage id="actions.cancel" />
						</Button>,
						<Button key="delete" type="danger" onClick={onDeleteAll}>
							<FormattedMessage id="actions.delete" />
						</Button>
					]
			}
		>
			{recurrent ?
				intl.formatMessage(
					{ id: 'messagePrograms.details.delete.confirm.message' },
					{
						date: intl.formatDate(eventStart, {
							day: 'numeric',
							month: 'long',
							year: 'numeric',
							hour: '2-digit',
							minute: '2-digit'
						})
					}
				)
			:	intl.formatMessage({
					id: 'messagePrograms.details.delete.confirmOneTime.message'
				})
			}
		</Modal>
	)
}

export default injectIntl(DeleteEventConfirmModal)
